<template>
    <div>
        <ul class="list">
            <li v-for="(item,  index) in list" v-bind:key="index">
                <div class="head">
                    <span>{{item.CREATE_TIME}}  </span>
                    <span class="right">已完成</span>
                </div>
                <div class="left">
                    <img :src="imageURL" alt="">
                </div>
                <div @click="goConfirm(item.RECORD_ID)">
                <div class="right">
                    <span>{{item.TYPE}}</span>
                    <div class="gray"><span>{{item.NAME}}</span><span class="num">{{item.PHONE_NUM}}</span></div>
                </div>
                <div class="items">
                    <ul>
                        <li>
                            <span>【基础项目】</span><span class="num">x{{item.BASIC}}</span>
                        </li>
                        <li>
                            <span>【新增项目】</span><span class="num">x{{item.ADDITEMS}}</span>
                        </li>
                    </ul>
                </div>
                <div class="total">
                    <span>小计：</span><b>¥{{item.PRICE}}</b>
                </div> </div>
                
            </li>
        </ul>
        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="pops" @confirm="confirmQX" @cancel="showPop = false" id="pops" />
        </van-popup>
    </div>
</template>


<script>
  import api from '@/fetch/api';
    import {
        Dialog,
        Toast,
        Popup,
        Picker
    } from 'vant';
     import {
        mapGetters
    } from 'vuex';
    // Vue.use(Popup);
    // Vue.use(Picker);
    export default {
        data() {
            return {
                imageURL: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1528431608002&di=00ad850a978b02b196e003a24b19c6c2&imgtype=0&src=http%3A%2F%2Fimg.mp.itc.cn%2Fupload%2F20170413%2F168a43e2babc420d9fe640a2286cb7c6_th.jpeg',
                list: [],
                allchecked: false,
                num: 0,
                totalPrice: 0,
                showPop: false,
                pops: ['我不想买了', '信息填写错误', '另选套餐', '其他原因']
            }
        },
         created() {
            sessionStorage.removeItem('records');
            this.orderBind();
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
             orderBind() {
                api.goFinish(this.userInfo.CUSTOMER_ID).then(re => {
                    console.log(re);
                    let list = re.data.FinishList;
                    this.list = [];
                    list.forEach(el => {
                        let type = '';
                        if (el.BATCH_ID != undefined)
                            type = '团检订单';
                        else
                            type = (el.TYPE=='固定套餐'?el.COMBO_NAME: el.TYPE);
                        this.list.push({
                            PHONE_NUM: el.PHONE_NUM,
                            PRICE: el.TOTAL,
                            SHOPPING_TIME: el.SHOPPING_TIME,
                            ADDITEMS: el.ADDITEMS,
                            RECORD_ID: el.RECORD_ID,
                            TYPE: type,
                            BASIC: el.BASIC,
                            NAME: el.NAME,
                            CREATE_TIME: el.CREATE_TIME,
                            BATCH_ID: el.BATCH_ID,
                            checked: false
                        })
                    });
                })
            },
            change() {
                this.list.forEach(n => {
                    n.checked = this.allchecked;
                })
            },
            tuikuan() {
                Dialog.confirm({
                    title: '退款',
                    message: '确定退款吗？'
                }).then(() => {
                    Toast.loading({
                        mask: true,
                        message: '处理中...'
                    });
                    setTimeout(() => {
                        Toast.success('退款成功！');
                    }, 3000);
                }).catch(() => {
                    // on cancel
                });
            },
            goConfirm(orderID) {
                let item = this.list.find(p => p.RECORD_ID == orderID);
                let selItem = {
                    PHONE_NUM: item.PHONE_NUM,
                    PRICE: item.PRICE,
                    RECORD_ID: item.RECORD_ID,
                    TYPE: item.TYPE,
                    NAME: item.NAME
                };
                console.log(selItem);
                sessionStorage.setItem('records', JSON.stringify(selItem));
                this.$router.push('/user/confirmCX/' + orderID);
            },
            goYuYue(orderID) {
                let item = this.list.find(p => p.RECORD_ID == orderID);
                let selItem = {
                    PHONE_NUM: item.PHONE_NUM,
                    PRICE: item.PRICE,
                    RECORD_ID: item.RECORD_ID,
                    TYPE: item.TYPE,
                    NAME: item.NAME
                };
                console.log(selItem);
                sessionStorage.setItem('records', JSON.stringify(selItem));
                this.$router.push('/user/singleYuYue/'+orderID);
            },
            itemchange() {
                this.num = 0;
                this.totalPrice = 0;
                this.list.forEach(n => {
                    if (!n.checked) {
                        this.allchecked = false;
                    } else {
                        this.num++;
                        this.totalPrice +=  parseFloat(n.PRICE);
                    }
                })
            },
            quxiao() {
                this.showPop = true;
            },
            confirmQX(){
                 this.showPop = false;
                Toast.success('欢迎下次光临');

            }
        },
    }
</script>

<style scoped lang='less'>
    .van-checkbox {
        display: inline;
    }
    .buy {
        .btnbuy {
            padding: 0 1em;
        }
        .price {
            span {
                display: inline;
                font-size: 0.8rem !important;
                margin-left: 8em;
            }
        }
    }
    .pay {
        .head {
            padding: 0.5em;
            position: relative;
            text-align: center;
            border-bottom: 1px solid rgb(226, 226, 226);
            .iconfont {
                position: absolute;
                left: 0.3em;
                top: 0.4em;
            }
        }
        button {
            background: #99C51D;
            margin: 4em 1em 1em 1em;
            color: #fff;
            font-weight: bold;
            font-size: 1rem;
            width: 95%;
            border-radius: 10px;
            height: 2em;
        }
        h1 {
            text-align: center;
            font-weight: normal;
            padding: 1em 0 0.3em 0;
        }
        ul {
            li {
                font-size: 0.8rem;
                color: #333;
            }
        }
        .items {
            border-bottom: 1px solid rgb(226, 226, 226);
            position: relative;
            margin-bottom: 0.4em;
            img {
                position: absolute;
                left: 1em;
                top: 0;
                width: 2.5em;
            }
            >div {
                margin-left: 5em;
                h1 {
                    color: #333;
                }
                h2 {
                    color: #999;
                }
                h1,
                h2 {
                    padding: 0;
                    margin: 0;
                    text-align: left;
                    font-size: 0.9em;
                    background: #fff;
                    line-height: 1.5em;
                }
            }
            i {
                position: absolute;
                right: 1em;
                top: 0.4em;
                color: #999;
            }
            .active {
                color: #99C51D;
            }
        }
    }
    .gray {
        color: #BCBCBC;
    }
    .num {
        position: absolute;
        right: 1em;
    }
    .list {
        .head {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E;
            border-top: 0px;
            border-right: 0px;
            border-bottom: 0px;
            padding-left: 1em;
            font-size: 0.8rem;
            height: 2.5em;
            line-height: 2.5em;
            border-bottom: 1px solid #eee;
            .right {
                position: absolute;
                right: 2em;
                top: 0;
                margin-top: 0;
                font-size: 0.8rem;
                color: #FF7C3E;
            }
        }
        .btns {
            position: absolute;
            bottom: 0;
            clear: both;
            text-align: right;
            font-size: 0.8rem;
            padding-top: 0.5em;
            width: 100%;
            left: 0;
            border-top: 1px solid #eee;
            button {
                border-radius: 15px;
                border: 1px solid #ccc;
                color: #666;
                width: 6em;
                text-align: center;
                line-height: 1.8em;
                margin-bottom: 0.4em;
                background: #fff;
                margin-left: 1em;
            }
            .blue {
                color: #99C51D;
                border-color: #99C51D;
            }
        }
        .right {
            margin-top: 0.5em;
            font-size: 1rem;
            >span {
                display: block;
                line-height: 2em;
            }
        }
        .total {
            text-align: right;
            font-size: 0.8rem;
            margin-top: 0.5em;
            b {
                font-size: 1rem;
                color: #FF7C3E;
            }
        }
        .items {
            margin-top: 0.8em;
            li {
                position: relative;
                font-size: 0.8rem;
            }
        }
        >li {
            height: 11em;
            position: relative;
            padding: 2em 1em 0.2em 9em;
            border-bottom: 1px solid #eee;
            overflow: hidden;
        }
        .left {
            position: absolute;
            left: 1em;
            top: 1em;
            .van-checkbox {
                position: absolute;
                top: 5.5em;
                left: 0;
            }
            img {
                width: 5em;
                height: 4em;
                position: absolute;
                left: 2em;
                top: 2em;
            }
        }
       
    }

    
</style>


// WEBPACK FOOTER //
// src/pages/orderFinish.vue